var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1252_19429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9.4917,
    width: 39.5676,
    height: 36,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7895 19.4917C22.3153 19.4917 18.6353 26.6802 18.4867 26.9773L18.2239 27.4916L18.4753 28.0059C18.6353 28.303 22.3153 35.4915 29.7895 35.4915C37.2637 35.4915 40.9436 28.303 41.0922 28.0059L41.3436 27.4916L41.0922 26.9773C40.9436 26.6802 37.2637 19.4917 29.7895 19.4917ZM29.7895 33.2058C24.7838 33.2058 21.7896 28.9773 20.8181 27.4916C21.7896 26.0059 24.7838 21.7774 29.7895 21.7774C34.7951 21.7774 37.7894 26.0059 38.7608 27.4916C37.7894 28.9773 34.7951 33.2058 29.7895 33.2058Z",
    fill: "#00406A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7896 22.9202C28.8855 22.9202 28.0017 23.1883 27.2499 23.6906C26.4982 24.1929 25.9122 24.9068 25.5662 25.7422C25.2202 26.5775 25.1297 27.4966 25.3061 28.3834C25.4825 29.2701 25.9179 30.0847 26.5572 30.724C27.1965 31.3633 28.0111 31.7987 28.8978 31.9751C29.7846 32.1515 30.7037 32.061 31.539 31.715C32.3744 31.369 33.0883 30.783 33.5906 30.0313C34.0929 29.2795 34.361 28.3957 34.361 27.4915C34.361 26.2791 33.8794 25.1164 33.0221 24.2591C32.1648 23.4018 31.0021 22.9202 29.7896 22.9202ZM29.7896 29.7772C29.3376 29.7772 28.8957 29.6432 28.5198 29.392C28.1439 29.1409 27.8509 28.7839 27.6779 28.3662C27.5049 27.9486 27.4597 27.489 27.5479 27.0456C27.6361 26.6023 27.8538 26.195 28.1734 25.8753C28.4931 25.5557 28.9003 25.338 29.3437 25.2498C29.7871 25.1616 30.2467 25.2068 30.6643 25.3798C31.082 25.5528 31.439 25.8458 31.6901 26.2217C31.9413 26.5976 32.0753 27.0395 32.0753 27.4915C32.0753 28.0978 31.8345 28.6791 31.4059 29.1078C30.9772 29.5364 30.3958 29.7772 29.7896 29.7772Z",
    fill: "#00406A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1252_19429",
    x: 0,
    y: 0.491699,
    width: 59.5676,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1252_19429"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1252_19429",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIc);
export default __webpack_public_path__ + "static/media/previewIc.e32b70d72572d8b321dfc43742ece132.svg";
export { ForwardRef as ReactComponent };